import { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import { auth, ApiError } from '../lib/api'
import { AuthLayout, ErrorBox, Field, SubmitButton } from '../components/AuthLayout'

export function TotpLogin() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const [params] = useSearchParams()
  const challenge = params.get('challenge') || ''
  const [code, setCode] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError('')
    setBusy(true)
    try {
      await auth.loginTOTP(challenge, code)
      await queryClient.invalidateQueries({ queryKey: ['me'] })
      navigate('/dashboard')
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Code klopt niet.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <AuthLayout title="Verificatiecode">
      <ErrorBox>{error}</ErrorBox>
      <p className="mb-4 text-sm text-ink-soft">Voer de code uit je authenticator-app in.</p>
      <form onSubmit={onSubmit}>
        <Field
          label="Code"
          type="text"
          inputMode="numeric"
          pattern="[0-9]{6}"
          maxLength={6}
          required
          autoFocus
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />
        <SubmitButton disabled={busy}>Doorgaan</SubmitButton>
      </form>
    </AuthLayout>
  )
}
